import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { MeasurementChartMonthsVersions } from "../../entities/tech-pack-versions/measurement-chart-6-12-months-versions.entity";


@Injectable()
export class MeasurementChartMonthsVersionsRepo extends Repository<MeasurementChartMonthsVersions> {

    constructor(@InjectRepository(MeasurementChartMonthsVersions) private measurementChartMonthsRepo: Repository<MeasurementChartMonthsVersions>
    ) {
        super(measurementChartMonthsRepo.target, measurementChartMonthsRepo.manager, measurementChartMonthsRepo.queryRunner);
    }

}